
        var result = require("!!../../../../node_modules/.pnpm/css-loader@2.1.1_webpack@5.101.3/node_modules/css-loader/dist/cjs.js!./font-awesome.min.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    